import { API } from './config'

export const markNotificationRead = (notifId) =>
  API.put('/sync-notif-state', { notifId })
    .then(() => true)
    .catch(() => false)
